<template>
  <v-layout wrap align-center v-if="user.consultor">
    <template v-if="loading">
      <v-flex
        :style="$style + '; overflow: hidden;'"
        xs12>
        <Loading :text="strings[idioma].carregando"/>
      </v-flex>
    </template>
    <v-flex
      v-show="!loading"
      xs12>
      <template v-if="titulo">
        <h3 style="text-align: center; color: #eee; text-shadow: #fff 1px 1px 2px; font-weight: bold!important;">{{ titulo }}</h3>
      </template>

      <v-autocomplete
        v-model="cliente"
        :item-text="item => (item.nome_fazenda) ? item.nome + ' - ' + item.nome_fazenda : item.nome"
        :items="ClientesLista"
        :browser-autocomplete="rand()"
        :style="$style"
        item-value="id"
        no-data-text=""
        class="purple-input"
        @change="changeCliente"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    $style: String,
    // eslint-disable-next-line vue/require-default-prop
    titulo: String
  },
  data: () => ({
    clientes: [],
    cliente: -2,
    cliente_: {
      nome: '',
      email: '',
      telefone: '',
      obs: '',
      id_consultor: null
    },
    dialog: false,
    dialogConsultoria: false,
    loading: false
  }),
  computed: {
    ...mapState('app', ['consultoria', 'menus', 'idioma', 'strings', 'user', 'empresa', 'responsive', 'curr_version', 'msgState']),
    ClientesLista () {
      let cl = this.consultoria && this.consultoria.clientes ? this.consultoria.clientes : []
      let lista = [{ id: -1, nome: '➕ ' + this.strings[this.idioma].clientes }, { id: -2, nome: '- ' + this.strings[this.idioma].uso_pessoal }]
      lista.push(...(cl !== null ? cl : []))
      return lista
    }

  },
  watch: {
    'consultoria.clienteSelecionado' (val) {
      this.cliente = val ? val.id : (-2)
    },
    'cliente' (val) {
      console.log({ val })
      if (val === -1) window.open('/consultor?ref=clientes&action=novo')
      this.setClienteSelecionado({ clienteID: val })
    }
  },
  async created () {
    if (this.user.consultoria && this.user.consultoria !== null && this.user.consultoria.id) {
      this.loading = true
      try {
        await this.getClientes({ user: this.user })
        localStorage.getItem('cliente') && this.setClienteSelecionado({ clienteID: JSON.parse(localStorage.getItem('cliente')).id })
        this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')).id : -2
      } finally {
        this.loading = false
      }
    }
  },
  methods: {
    ...mapActions(['getClientes', 'setClienteSelecionado']),
    async openConsultoria () {
      await this.get()
      this.dialogConsultoria = true
    },
    editarCliente (cliente) {
      this.cliente_ = cliente
      this.dialog = true
    },
    removerCliente (cliente) {
      if (confirm(this.strings[this.idioma].msg_remove)) {
        this.axios.post('consultoria/clientes/delete', { ...cliente }).then(_ => {
          alert('Removido com sucesso!!!')
          this.get()
        }).catch(_ => {
          alert('Erro ao remover!!!')
        })
      }
    },
    descartar () {
      this.cliente_ = {
        nome: '',
        email: '',
        telefone: '',
        obs: '',
        id_consultor: this.user.consultoria.id
      }
      let cliente = JSON.parse(localStorage.getItem('cliente'))
      this.cliente = cliente ? cliente.id : -2
      this.dialog = false
      this.get()
    },
    async get () {
      return this.axios.post('consultoria/clientes', { id: this.user.consultoria.id }).then(r => {
        this.clientes = r.data.data
        let cliente = JSON.parse(localStorage.getItem('cliente'))
        if (cliente && cliente !== null) this.cliente = cliente.id
      })
    },
    save () {
      this.axios.post('consultoria/clientes/create', { ...this.cliente_ }).then(r => {
        alert('Salvo com sucesso!!!')
        
      }).catch(r => {
        alert('Houve um problema ao cadastrar o cliente. Verifique se não excedeu o número máximo de clientes permitidos!')
      }).then(_ => {
        let cliente = JSON.parse(localStorage.getItem('cliente'))
        this.cliente = cliente ? cliente.id : -2
        this.dialog = false
        this.get()
      })
    },
    changeCliente () {
      if (this.cliente !== -1) {
        setTimeout(r => {
          this.setClienteSelecionado({ clienteID: this.cliente })
          window.location.reload()
        }, 100)
      } else {
        this.cliente_ = {
          nome: '',
          email: '',
          telefone: '',
          obs: '',
          id_consultor: this.user.consultoria.id
        }
        this.dialog = true
      }
    }
  }

}
</script>
